import * as React from 'react';
import * as I18n from 'i18n-js';
import track from 'react-tracking';

import HeaderDropdown from '@reverbdotcom/commons/dist/components/header_dropdown';
import NewsDropdown from './news_dropdown';
import CategoryFlyoutHeader from './category_flyout_header';
import CoreLink from '@reverbdotcom/commons/dist/components/core_link';
import URLHelpers from '../shared/url_helpers';
import { experiments } from '../shared/constants';

import { withUserContext, IUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';
import { isExperimentEnabled } from '@reverbdotcom/commons/dist/user_context_helpers';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/dist/elog/mparticle';
import { MParticleEventName } from '@reverbdotcom/commons/dist/elog/mparticle_types';

const CATEGORIES = [
  'electric-guitars',
  'acoustic-guitars',
  'bass-guitars',
  'amps',
  'effects-and-pedals',
  'drums-and-percussion',
  'pro-audio',
  'keyboards-and-synths',
  'dj-and-lighting-gear',
  'pro-audio/microphones',
  'folk-instruments',
  'band-and-orchestra',
  'software',
  'home-audio',
  'accessories',
  'parts',
];

interface IProps extends IUserContext {
  activeDropdown: string;
  onOpen: (key: string) => void;
}

@track((props: IProps) => ({
  mParticleInteraction: (event) => ({
    experiments: formatExperimentsForEventAttributes(props.user, [experiments.CATEGORY_FLYOUT]),
    eventName: MParticleEventName.NavBarInteraction,
    entityId: event.entityId,
  }),
}))
export class Headerv2Categories extends React.Component<IProps, null> {
  componentDidMount() {
    window.addEventListener('resize', this.resetCategoryScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resetCategoryScroll);
  }

  // Category list scroll position must be reset above mobile sizing
  // otherwise, not all categories will be displayed in the MORE dropdown.
  resetCategoryScroll() {
    if (window.innerWidth <= 640) return;
    const categoryScroll = document.querySelector('.site-header__categories__inner');

    if (categoryScroll) {
      categoryScroll.scrollLeft = 0;
    }
  }

  getOverflowCategories() {
    if (!window.document) { return []; }

    const moreLink = document.querySelector('.site-header__categories__view-more');

    return CATEGORIES.filter((cat) => {
      const catLink = document.querySelector(
        `.site-header__category [data-header-category="${cat}"]`);
      if (!catLink || !moreLink) return;
      return catLink.getBoundingClientRect().right > moreLink.getBoundingClientRect().left;
    });
  }

  renderOverflowCategories() {
    const cats = this.getOverflowCategories();
    if (!cats.length) return;

    return cats.map((slug) => {
      return this.renderCategoryLink(slug);
    });
  }

  renderCategories() {
    return CATEGORIES.map((slug) => {
      return this.renderCategoryLink(slug);
    });
  }

  renderCategoryLink(slug) {
    return (
      <div
        key={slug}
        className="site-header__category"
      >
        <CoreLink
          key={slug}
          className="site-header__category__link"
          activeClassName="site-header__category__link--active"
          onlyActiveOnIndex
          entityId={slug}
          to={URLHelpers.categoryPagePath(slug)}
        >
          <span
            data-header-category={slug}
          >
            {I18n.t(`discovery.categories.${slug}`)}
          </span>
        </CoreLink>
      </div>
    );
  }

  renderViewMoreTrigger() {
    return (
      <button className="site-header__categories__view-more">
        {I18n.t('discovery.categories.viewMore')}
      </button>
    );
  }

  renderViewMore() {
    return (
      <HeaderDropdown
        trigger={this.renderViewMoreTrigger()}
        contents={this.renderOverflowCategories()}
        onOpen={this.props.onOpen}
        dropdownKey="more"
        activeDropdownKey={this.props.activeDropdown}
      />
    );
  }

  renderNewsTrigger() {
    return (
      <CoreLink
        to="/news"
        entityId="news"
        className="site-header__nav__link site-header__nav__link--articles"
      >
        {I18n.t('discovery.navLinks.reverbNews')}
      </CoreLink>
    );
  }

  renderNavLinks() {
    return (
      <ul className="site-header__nav__links">
        <li className="site-header__nav__news">
          <HeaderDropdown
            trigger={this.renderNewsTrigger()}
            contents={<NewsDropdown />}
            onOpen={this.props.onOpen}
            dropdownKey="news"
            activeDropdownKey={this.props.activeDropdown}
          />
        </li>

        <li>
          <CoreLink
            to="/price-guide"
            className="site-header__nav__link"
            entityId="price-guide"
          >
            {I18n.t('discovery.navLinks.priceGuide')}
          </CoreLink>
        </li>

        <li>
          <CoreLink
            to="/page/reverb-gives"
            entityId="reverb-gives"
            className="site-header__nav__link"
          >
            {I18n.t('discovery.navLinks.reverbGives')}
          </CoreLink>
        </li>

        <li>
          <CoreLink
            to="/shops"
            className="site-header__nav__link"
            entityId="shops"
          >
            {I18n.t('discovery.navLinks.shops')}
          </CoreLink>
        </li>
      </ul>
    );
  }

  render() {
    if (isExperimentEnabled(this.props.user, experiments.CATEGORY_FLYOUT)) {
      return <CategoryFlyoutHeader />;
    }

    return (
      <div className="site-header__categories">
        <div className="site-header__categories__inner">
          {this.renderCategories()}
        </div>
        {this.renderViewMore()}
        {this.renderNavLinks()}
      </div>
    );
  }
}

export default withUserContext(Headerv2Categories);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/new_header/headerv2_categories.tsx